<p>self-check-report works!</p>
